import React from 'react';
import CheckoutContext from "../../checkout-context";

// Options must be an array, map is used
class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: !this.props.required && this.props.placeHolder,
            isTouched: false
        }
    }

    static contextType = CheckoutContext;

    componentDidMount() {
        this.checkInputFields();
    }

    checkInputFields = () => {
        const {
            path,
            required,
            placeHolder,
            errorMessage
        } = this.props;

        const {
            getData,
            updateFieldValidity
        } = this.context;

        if (required && placeHolder) {
            updateFieldValidity(path, 'select', !!getData(path), errorMessage === undefined ? this.props.resourcedTexts.inputErrorMessageDefault : errorMessage);
        } else {
            updateFieldValidity(path, 'select', true);
        }
    };

    checkValidation = () => {
        this.setState({
            isTouched: true
        });
    };

    render() {
        const {
            inputLabel,
            options,
            placeHolder,
            required,
            errorMessage
        } = this.props;

        const {
            getData,
            setData,
            errors,
            updateFieldValidity
        } = this.context;

        const mySetData = (path, value) => {
            setData(path, value);

            if (required && placeHolder) {
                updateFieldValidity(path, 'select', !!getData(path), errorMessage === undefined ? this.props.resourcedTexts.inputErrorMessageDefault : errorMessage);
            } else {
                updateFieldValidity(path, 'select', true);
            }
        };

        return (
            <div 
                className={`form-field ${this.state.isTouched ? 'is-touched' : ''} ${errors[this.props.path] ? 'is-invalid' : ''}`}>
                <label htmlFor={this.props.path}>{inputLabel}</label>
                <select onChange={(e) => mySetData(this.props.path, e.target.value)}
                        onBlur={() => this.checkValidation()}
                        id={this.props.path}
                        value={getData(this.props.path)}>
                    {placeHolder ? 
                        <option value='' disabled>{placeHolder}</option> : null
                    }
                    {options.map(option => {
                        return (
                            <option value={option.value} key={option.value}>{option.name}</option>
                        )
                    })}
                </select>
                <span className={`field-validation-error`}>
                    {errors[this.props.path]}
                </span>
            </div>
        )
    }
}

export default Select;